import React, { lazy, Suspense, useState } from 'react';
import { Clock } from 'lucide-react';
import { Translations } from '../i18n/translations';

// Sudoku is only used after the time limit fires — keep it out of the
// initial bundle for the 99% of sessions that never hit the overlay.
const Sudoku = lazy(() => import('./Sudoku').then(m => ({ default: m.Sudoku })));

interface TimeLimitOverlayProps {
  dailyTimeLimit: number;
  t: Translations;
}

export const TimeLimitOverlay: React.FC<TimeLimitOverlayProps> = ({
  dailyTimeLimit,
  t,
}) => {
  const [showSudoku, setShowSudoku] = useState(false);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center overflow-auto py-8">
      <div className="bg-white dark:bg-gray-800 border-4 border-black dark:border-gray-600 p-8 max-w-lg text-center">
        {!showSudoku ? (
          <>
            <Clock className="w-16 h-16 mx-auto mb-4 text-gray-700 dark:text-gray-300" />
            <h2 className="text-3xl font-bold font-serif mb-4 text-gray-900 dark:text-white">{t.timesUp}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              {t.timeLimitReached.replace('{minutes}', dailyTimeLimit.toString())}
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              {t.limitResetsAtMidnight}
            </p>
            <button
              onClick={() => setShowSudoku(true)}
              className="px-6 py-3 bg-blue-600 text-white font-semibold border-2 border-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:border-blue-500 dark:hover:bg-blue-600"
            >
              {t.playSudoku}
            </button>
          </>
        ) : (
          <Suspense fallback={<div className="text-gray-500 dark:text-gray-400">Loading…</div>}>
            <Sudoku />
          </Suspense>
        )}
      </div>
    </div>
  );
};
